var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTouchAndDrag = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 13.1V3.3h2.45v5.1q3.65-3.15 8.125-4.775Q19.05 2 23.9 2t9.375 1.625Q37.8 5.25 41.5 8.4V3.3H44v9.8h-9.55v-2.45h6q-3.45-3-7.7-4.7-4.25-1.7-8.85-1.7-4.55 0-8.75 1.7t-7.65 4.7h6v2.45ZM21.1 46q-.85 0-1.6-.325-.75-.325-1.3-.875L7.9 34.5l2.8-2.9q.7-.7 1.575-1.075T14.1 30.4l3.9.9V15q0-2.1 1.45-3.55Q20.9 10 23 10q2.1 0 3.55 1.45Q28 12.9 28 15v9h1.3q.25 0 .475.05.225.05.475.15l7.35 3.3q1.2.55 1.775 1.775.575 1.225.325 2.525l-1.8 10.9q-.25 1.45-1.4 2.375T33.9 46Zm-.4-3h14.05l2.15-12.45-9.15-4.15H25V15q0-.9-.55-1.45Q23.9 13 23 13q-.9 0-1.45.55Q21 14.1 21 15v19.95l-7.7-1.65-1.15 1.15Zm0 0h14.05Z"
  })));
};
export { SvgTouchAndDrag as ReactComponent };